export default __webpack_public_path__ + "static/media/ns.64c31f91.png";